<template>
  <div class="w-full h-full grid grid-rows-[1fr_max-content] overflow-hidden">
    <div
      class="relative flex items-center p-5 overflow-hidden"
      @touchstart="handleTouchStart"
      @touchend="handleTouchEnd"
    >
      <button
        @click.stop="closeModal"
        class="w-12.5 aspect-square rounded-full border border-transparent text-dustrose bg-burgundy flex items-center justify-center absolute top-5 right-5 cursor-pointer hover:text-burgundy hover:bg-dustrose hover:border-burgundy transition-[background-color_color_border]"
      >
        <IconSprite id="close" />
      </button>
      <ArrowButton v-if="images.length > 1" reverse @click.stop="goBack" />
      <Transition name="fade" mode="out-in">
        <ResponsiveImage
          :media="images[current]"
          class="w-full max-h-full max-w-250 mx-auto"
          :key="`carousel-image-${current}`"
        />
      </Transition>
      <ArrowButton v-if="images.length > 1" @click.stop="goForward" />
    </div>
    <div class="flex gap-2 p-4 overflow-auto max-w-full lg:w-max lg:mx-auto">
      <button
        v-for="(image, imageIndex) in images"
        :key="`carousel-steps-${imageIndex}`"
        :class="[
          'shrink-0 w-22.5 aspect-square border-2 border-transparent transition-[border] cursor-pointer hover:border-pink',
          { 'border-dustrose!': current === imageIndex },
        ]"
        @click.stop="goTo(imageIndex)"
      >
        <ResponsiveImage :media="image" class="w-full h-full object-cover" />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { ref } from 'vue'

import IconSprite from '@/components/helpers/IconSprite.vue'
import ResponsiveImage from '@/components/helpers/ResponsiveImage.vue'
import ArrowButton from '@/components/small/ArrowButton.vue'
import { useCarousel } from '@/composables/useCarousel.ts'
import { useModalStore } from '@/stores/modal.ts'

export default {
  name: 'CarouselModal',
  components: { ArrowButton, IconSprite, ResponsiveImage },
  setup() {
    const store = useModalStore()

    const { current, goBack, goForward, goTo } = useCarousel((store.data?.images.length ?? -1) - 1)

    const touchStartXPosition = ref(0)

    const handleTouchStart = (event: TouchEvent) => {
      touchStartXPosition.value = event.changedTouches[0].clientX
    }

    const handleTouchEnd = (event: TouchEvent) => {
      if (touchStartXPosition.value >= event.changedTouches[0].clientX) {
        goForward()
      } else {
        goBack()
      }
    }

    return {
      current,
      images: store.data?.images ?? [],
      closeModal: store.close,
      goBack,
      goForward,
      goTo,
      handleTouchStart,
      handleTouchEnd,
    }
  },
}
</script>
